import React from "react";
import Account from "../../coach/account/Account";

function HighSchoolAccountPage() {
  return (
    <div className="bg-gray-100 p-4 h-full">
      <Account />
    </div>
  );
}

export default HighSchoolAccountPage;
